<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">{{ brand.description }}</h2>
      <span>|</span>
      <h2 class="title title-primary">
        {{ $t("lang.brand_page.boxstock.box") }}
      </h2>
    </div>

    <v-row class="justify-content-end pt-6 pb-0 px-12">
      <v-btn
        text
        dark
        class="mb-4"
        @click="download"
        v-if="this.filters.date && this.filters.date.date_start"
      >
        <v-avatar color="#27362F" class="pa-2 cursor-pointer">
          <img src="@/assets/i/Icon-download-w.svg" />
        </v-avatar>
      </v-btn>
    </v-row>

    <bx-box
      :title="$t('lang.brand_page.boxstock.cajas', { count: rowCount })"
      color="white"
      class="col-12 px-12"
    >
      <template v-slot:default>
        <bx-table
          :data="data.results"
          :columns="columns"
          paginated
          backendPagination
          :currentPage="page"
          :perPage="itemsPerPage"
          :total="rowCount"
          @search="onSearch"
          @update:currentPage="updatePage"
        >
          <template slot-scope="props">
            <bx-table-column centered>
              <router-link
                class="bx-link bx-link-bold"
                :to="{
                  name: 'pallet-tracking-detail',
                  params: { boxid: props.row.box_id }
                }"
              >
                {{ props.row.box_id }}
              </router-link>
            </bx-table-column>
            <bx-table-column centered>{{ props.row.box }}</bx-table-column>
            <bx-table-column centered>{{ props.row.location }}</bx-table-column>
            <bx-table-column centered>{{ props.row.area }}</bx-table-column>
            <bx-table-column centered>{{ props.row.date }}</bx-table-column>
            <bx-table-column centered>{{ props.row.cycles }}</bx-table-column>
            <bx-table-column>
              <img
                @click="downloadFile(props.row.box_id)"
                style="cursor: pointer"
                src="@/assets/i/Icon-download.svg"
              />
            </bx-table-column>
          </template>
        </bx-table>
      </template>
    </bx-box>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment/dist/moment";
export default {
  computed: {
    ...mapGetters({
      brand: "brand"
    })
  },
  data() {
    return {
      data: [],
      columns: [],
      rowCount: 0,
      page: 1,
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      filters: {
        date: "",
        location: null
      },
      locations: []
    };
  },
  beforeMount() {
    this.$store.dispatch("setSideMenu", "brand_menu");
  },
  mounted() {
    this.getLocations().then(() => this.getData());
  },
  methods: {
    async getLocations() {
      this.locations = await this.$api.brand.locations();
    },
    async getData() {
      this.columns = [
        {
          field: "box",
          label: this.$t("lang.brand_page.boxstock.caja"),
          centered: true,
          width: 80
        },
        {
            field: "box_code",
            label: this.$t("lang.brand_page.boxstock.barcode"),
            filter: {
              placeholder: this.$t(
                "lang.brand_page.boxstock.barcode"
              ),
              value: this.filters.box,
            },
            centered: true,
          },
        {
          field: "location",
          label: this.$t("lang.brand_page.boxstock.location"),
          filter: {
            placeholder: this.$t("lang.brand_page.boxstock.location"),
            value: this.filters.location,
            items: this.locations,
            isSelect: true
          },
          centered: true
        },
        {
          field: "area",
          label: this.$t("lang.brand_page.boxstock.area"),
          centered: true
        },
        {
          field: "date",
          label: this.$t("lang.brand_page.boxstock.date"),
          filter: {
            placeholder: this.$t("lang.brand_page.boxstock.date"),
            value: this.filters.date,
            isdateRange: true
          },
          centered: true
        },
        {
          field: "cycles",
          label: this.$t("lang.brand_page.boxstock.cycles"),
          centered: true
        },
        {
          field: "download",
          label: this.$t("lang.brand_page.boxstock.download"),
          centered: true
        }
      ];
      this.data = await this.$api.brand.boxStock({
        limit: this.itemsPerPage,
        offset: (this.page - 1) * this.itemsPerPage,
        area1__location__id: this.filters.location && this.filters.location.id,
        date__gte: this.filters.date && this.filters.date.date_start,
        date__lte: this.filters.date && this.filters.date.date_end,
        box__codebar__contains: this.filters.box,
        box_type:0
      });
      this.rowCount = this.data && this.data.count;
    },
    downloadFile(id) {
      this.$api.brand.download(id);
    },
    updatePage(p) {
      this.page = p;
      this.getData();
    },
    onSearch(field, value) {
      this.$session.set(this.key + field, value);
      switch (field) {
        case "location":
          var loc = this.locations.find(el => el["id"] === value);
          this.filters.location = loc;
          this.getData();
          return;
        case "date":
          this.filters.date = value;
          this.getData();
          return;
        case "box_code":
          this.filters.box = value;
          this.getData();
          return;
      }
    },
    formattedDate(date) {
      return date ? moment(date.toString()).format("YYYY-MM-DD") : "";
    },
    async download() {
      const fromDate =
        this.filters.date &&
        this.formattedDate(this.filters.date.date_start) + " 00:00:00";
      const toDate =
        this.filters.date &&
        this.formattedDate(this.filters.date.date_end) + " 23:59:59";
      const locationId = this.filters.location.id;
      await this.$api.brand.downloadCsv(locationId, fromDate, toDate);
    }
  }
};
</script>

<style></style>
